// extracted by mini-css-extract-plugin
export default {"cls1":"AuthorHeader-cls1__b3bca102928eb16d2e7d","cls2":"AuthorHeader-cls2___ef381fd2b6e5b9445b1 AuthorHeader-cls1__b3bca102928eb16d2e7d"};